import { render, staticRenderFns } from "./annex-import.vue?vue&type=template&id=71831e3a&scoped=true"
import script from "./annex-import.vue?vue&type=script&lang=ts"
export * from "./annex-import.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71831e3a",
  null
  
)

export default component.exports